// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReturnPanel_container__5Ryu9 {
  position: fixed;
  top: 0;
  right: 0;
  width: 85%;
  height: 100vh;
  background: #f9f9f9;
  z-index: 1000;
  padding: 25px 30px;
  overflow-y: auto;
  animation: ReturnPanel_slideIn__rV2oC 0.3s ease;
}

.ReturnPanel_quantityWrapper__BRN5I {
  display: flex;
  align-items: center;
  gap: 5px;
}

.ReturnPanel_quantityBtn__HcFr- {
  width: 28px;
  height: 28px;
  border: 1px solid #ccc;
  background-color: #f5f5f5;
  cursor: pointer;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.ReturnPanel_quantityBtn__HcFr-:hover {
  background-color: #e0e0e0;
}

.ReturnPanel_quantityInput__YZ56T {
  width: 50px;
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 4px;
  height: 28px;
}


@keyframes ReturnPanel_slideIn__rV2oC {
  from { right: -85%; }
  to { right: 0; }
}

.ReturnPanel_topBar__2MUQS {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 25px;
}

.ReturnPanel_finishModalOverlay__cbR1u {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.ReturnPanel_finishModal__AlwLa {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 12px;
  width: 400px;
  max-width: 90%;
  padding: 25px 20px;
  box-shadow: 0 8px 20px rgba(0,0,0,0.25);
  display: flex;
  flex-direction: column;
  gap: 15px;
  animation: ReturnPanel_fadeIn__BZM5q 0.2s ease-in-out;
}

@keyframes ReturnPanel_fadeIn__BZM5q {
  from { opacity: 0; transform: translate(-50%, -55%); }
  to { opacity: 1; transform: translate(-50%, -50%); }
}

.ReturnPanel_finishModal__AlwLa h3 {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  color: #333;
}

.ReturnPanel_finishModal__AlwLa label {
  font-size: 14px;
  color: #555;
  margin-bottom: 5px;
}

.ReturnPanel_finishModal__AlwLa select,
.ReturnPanel_finishModal__AlwLa textarea {
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 14px;
  outline: none;
  transition: border 0.2s;
}

.ReturnPanel_finishModal__AlwLa select:focus,
.ReturnPanel_finishModal__AlwLa textarea:focus {
  border-color: #4caf50;
}

.ReturnPanel_finishModal__AlwLa textarea {
  height: 80px;
  resize: none;
}

.ReturnPanel_finishModalButtons__nDYZ9 {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
}

.ReturnPanel_finishModalButtons__nDYZ9 button {
  padding: 10px 18px;
  font-size: 14px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.ReturnPanel_finishModalButtons__nDYZ9 button:first-of-type {
  background-color: #1d8752;
  color: #fff;
}

.ReturnPanel_finishModalButtons__nDYZ9 button:first-of-type:hover:not(:disabled) {
  background-color: #166a42;
}

.ReturnPanel_finishModalButtons__nDYZ9 button:first-of-type:disabled {
  background-color: #a5d6a7;
  cursor: not-allowed;
}

.ReturnPanel_finishModalButtons__nDYZ9 button:last-of-type {
  background-color: #f1f1f1;
  color: #333;
}

.ReturnPanel_finishModalButtons__nDYZ9 button:last-of-type:hover {
  background-color: #e0e0e0;
}

.ReturnPanel_finishModalClose__dIZqs {
  position: absolute;
  top: 12px;
  right: 15px;
  font-size: 20px;
  font-weight: bold;
  color: #999;
  cursor: pointer;
  transition: color 0.2s;
}

.ReturnPanel_finishModalClose__dIZqs:hover {
  color: #333;
}


.ReturnPanel_backBtn__b\\+Tue {
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
}

.ReturnPanel_title__NLFF5 {
  font-size: 20px;
  font-weight: 600;
}

.ReturnPanel_infoRow__Bj\\+Er {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.ReturnPanel_infoCard__RFKaq {
  flex: 1 1;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 20px;
}

.ReturnPanel_infoLabel__ic-\\+7 {
  font-size: 14px;
  color: #888;
  margin-bottom: 8px;
}

.ReturnPanel_infoLabelSupp__ZmutF {
  font-size: 16px;
  color: black;
  font-weight: bold;
  margin-bottom: 8px;
}

.ReturnPanel_infoValue__riob0 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 5px;
}

.ReturnPanel_changeBtn__JFxEO {
  font-size: 12px;
  color: rgba(29, 135, 82, 1);
  background: none;
  border: none;
  cursor: pointer;
}


.ReturnPanel_supplierIcon__-elPh {
  font-size: 26px;
  color: rgba(29, 135, 82, 1);
}

.ReturnPanel_totalPrice__maQ-E {
  color: rgba(29, 135, 82, 1);
  font-size: 22px;
  font-weight: 700;
}

.ReturnPanel_search__frK3E {
  width: 100%;
  padding: 12px;
  margin-right: 10px;
  border-radius: 8px;
  background: white;
  border: 1px solid #dcdcdc;
}

.ReturnPanel_actionRow__BhceE {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
}

.ReturnPanel_select__RGx5- {
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ddd;
}

.ReturnPanel_addProductBtn__Y6rYJ {
  padding: 10px 18px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
}

.ReturnPanel_finishBtn__KbAQQ {
  margin-left: auto;
  padding: 10px 18px;
  background: #000;
  color: white;
  border-radius: 8px;
  border: none;
  cursor: pointer;
}

.ReturnPanel_table__e2rLb {
  width: 100%;
  background: white;
  border-radius: 10px;
  border-collapse: collapse;
}

.ReturnPanel_table__e2rLb th {
  text-align: left;
  padding: 12px;
  font-size: 13px;
  color: #777;
}

.ReturnPanel_table__e2rLb td {
  padding: 12px;
  border-top: 1px solid #eee;
}

.ReturnPanel_qtyInput__kubre,
.ReturnPanel_priceInput__vrlOs {
  width: 70px;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 6px;
}

.ReturnPanel_deleteIcon__vVtmO {
  cursor: pointer;
  color: red;
}

.ReturnPanel_searchWrapper__AYmEo {
  display: flex;
  position: relative;
  width: 100%;
  margin-bottom: 20px;
}

.ReturnPanel_searchResults__8PprG {
  position: absolute;
  top: 48px; 
  left: 0;
  width: 90%;
  max-height: 220px;
  background: white;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow-y: auto;
  z-index: 20;
}

.ReturnPanel_searchItem__OvmS8 {
  padding: 10px 14px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #f0f0f0;
}

.ReturnPanel_searchItem__OvmS8:hover {
  background: #f5f7ff;
}

.ReturnPanel_productName__zyAPm {
  font-size: 14px;
  font-weight: 500;
}

.ReturnPanel_productBarcode__GCf\\+e {
  font-size: 12px;
  color: #888;
}
`, "",{"version":3,"sources":["webpack://./src/pages/tables/customComponentsTable/ReturnPanel.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,+CAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;;AAGA;EACE,OAAO,WAAW,EAAE;EACpB,KAAK,QAAQ,EAAE;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qDAAkC;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE,gCAAgC,EAAE;EACrD,KAAK,UAAU,EAAE,gCAAgC,EAAE;AACrD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;;AAGA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb","sourcesContent":[".container {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 85%;\n  height: 100vh;\n  background: #f9f9f9;\n  z-index: 1000;\n  padding: 25px 30px;\n  overflow-y: auto;\n  animation: slideIn 0.3s ease;\n}\n\n.quantityWrapper {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.quantityBtn {\n  width: 28px;\n  height: 28px;\n  border: 1px solid #ccc;\n  background-color: #f5f5f5;\n  cursor: pointer;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n}\n\n.quantityBtn:hover {\n  background-color: #e0e0e0;\n}\n\n.quantityInput {\n  width: 50px;\n  text-align: center;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  height: 28px;\n}\n\n\n@keyframes slideIn {\n  from { right: -85%; }\n  to { right: 0; }\n}\n\n.topBar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 25px;\n}\n\n.finishModalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0,0,0,0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.finishModal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #fff;\n  border-radius: 12px;\n  width: 400px;\n  max-width: 90%;\n  padding: 25px 20px;\n  box-shadow: 0 8px 20px rgba(0,0,0,0.25);\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  animation: fadeIn 0.2s ease-in-out;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translate(-50%, -55%); }\n  to { opacity: 1; transform: translate(-50%, -50%); }\n}\n\n.finishModal h3 {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 600;\n  text-align: center;\n  color: #333;\n}\n\n.finishModal label {\n  font-size: 14px;\n  color: #555;\n  margin-bottom: 5px;\n}\n\n.finishModal select,\n.finishModal textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid #ccc;\n  font-size: 14px;\n  outline: none;\n  transition: border 0.2s;\n}\n\n.finishModal select:focus,\n.finishModal textarea:focus {\n  border-color: #4caf50;\n}\n\n.finishModal textarea {\n  height: 80px;\n  resize: none;\n}\n\n.finishModalButtons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.finishModalButtons button {\n  padding: 10px 18px;\n  font-size: 14px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.finishModalButtons button:first-of-type {\n  background-color: #1d8752;\n  color: #fff;\n}\n\n.finishModalButtons button:first-of-type:hover:not(:disabled) {\n  background-color: #166a42;\n}\n\n.finishModalButtons button:first-of-type:disabled {\n  background-color: #a5d6a7;\n  cursor: not-allowed;\n}\n\n.finishModalButtons button:last-of-type {\n  background-color: #f1f1f1;\n  color: #333;\n}\n\n.finishModalButtons button:last-of-type:hover {\n  background-color: #e0e0e0;\n}\n\n.finishModalClose {\n  position: absolute;\n  top: 12px;\n  right: 15px;\n  font-size: 20px;\n  font-weight: bold;\n  color: #999;\n  cursor: pointer;\n  transition: color 0.2s;\n}\n\n.finishModalClose:hover {\n  color: #333;\n}\n\n\n.backBtn {\n  background: none;\n  border: none;\n  font-size: 22px;\n  cursor: pointer;\n}\n\n.title {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.infoRow {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.infoCard {\n  flex: 1;\n  background: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 10px;\n  padding: 20px;\n}\n\n.infoLabel {\n  font-size: 14px;\n  color: #888;\n  margin-bottom: 8px;\n}\n\n.infoLabelSupp {\n  font-size: 16px;\n  color: black;\n  font-weight: bold;\n  margin-bottom: 8px;\n}\n\n.infoValue {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 5px;\n}\n\n.changeBtn {\n  font-size: 12px;\n  color: rgba(29, 135, 82, 1);\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n\n.supplierIcon {\n  font-size: 26px;\n  color: rgba(29, 135, 82, 1);\n}\n\n.totalPrice {\n  color: rgba(29, 135, 82, 1);\n  font-size: 22px;\n  font-weight: 700;\n}\n\n.search {\n  width: 100%;\n  padding: 12px;\n  margin-right: 10px;\n  border-radius: 8px;\n  background: white;\n  border: 1px solid #dcdcdc;\n}\n\n.actionRow {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-bottom: 20px;\n}\n\n.select {\n  padding: 10px;\n  border-radius: 8px;\n  border: 1px solid #ddd;\n}\n\n.addProductBtn {\n  padding: 10px 18px;\n  background: white;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.finishBtn {\n  margin-left: auto;\n  padding: 10px 18px;\n  background: #000;\n  color: white;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n}\n\n.table {\n  width: 100%;\n  background: white;\n  border-radius: 10px;\n  border-collapse: collapse;\n}\n\n.table th {\n  text-align: left;\n  padding: 12px;\n  font-size: 13px;\n  color: #777;\n}\n\n.table td {\n  padding: 12px;\n  border-top: 1px solid #eee;\n}\n\n.qtyInput,\n.priceInput {\n  width: 70px;\n  padding: 5px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n}\n\n.deleteIcon {\n  cursor: pointer;\n  color: red;\n}\n\n.searchWrapper {\n  display: flex;\n  position: relative;\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.searchResults {\n  position: absolute;\n  top: 48px; \n  left: 0;\n  width: 90%;\n  max-height: 220px;\n  background: white;\n  border: 1px solid #dcdcdc;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  overflow-y: auto;\n  z-index: 20;\n}\n\n.searchItem {\n  padding: 10px 14px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.searchItem:hover {\n  background: #f5f7ff;\n}\n\n.productName {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.productBarcode {\n  font-size: 12px;\n  color: #888;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ReturnPanel_container__5Ryu9`,
	"slideIn": `ReturnPanel_slideIn__rV2oC`,
	"quantityWrapper": `ReturnPanel_quantityWrapper__BRN5I`,
	"quantityBtn": `ReturnPanel_quantityBtn__HcFr-`,
	"quantityInput": `ReturnPanel_quantityInput__YZ56T`,
	"topBar": `ReturnPanel_topBar__2MUQS`,
	"finishModalOverlay": `ReturnPanel_finishModalOverlay__cbR1u`,
	"finishModal": `ReturnPanel_finishModal__AlwLa`,
	"fadeIn": `ReturnPanel_fadeIn__BZM5q`,
	"finishModalButtons": `ReturnPanel_finishModalButtons__nDYZ9`,
	"finishModalClose": `ReturnPanel_finishModalClose__dIZqs`,
	"backBtn": `ReturnPanel_backBtn__b+Tue`,
	"title": `ReturnPanel_title__NLFF5`,
	"infoRow": `ReturnPanel_infoRow__Bj+Er`,
	"infoCard": `ReturnPanel_infoCard__RFKaq`,
	"infoLabel": `ReturnPanel_infoLabel__ic-+7`,
	"infoLabelSupp": `ReturnPanel_infoLabelSupp__ZmutF`,
	"infoValue": `ReturnPanel_infoValue__riob0`,
	"changeBtn": `ReturnPanel_changeBtn__JFxEO`,
	"supplierIcon": `ReturnPanel_supplierIcon__-elPh`,
	"totalPrice": `ReturnPanel_totalPrice__maQ-E`,
	"search": `ReturnPanel_search__frK3E`,
	"actionRow": `ReturnPanel_actionRow__BhceE`,
	"select": `ReturnPanel_select__RGx5-`,
	"addProductBtn": `ReturnPanel_addProductBtn__Y6rYJ`,
	"finishBtn": `ReturnPanel_finishBtn__KbAQQ`,
	"table": `ReturnPanel_table__e2rLb`,
	"qtyInput": `ReturnPanel_qtyInput__kubre`,
	"priceInput": `ReturnPanel_priceInput__vrlOs`,
	"deleteIcon": `ReturnPanel_deleteIcon__vVtmO`,
	"searchWrapper": `ReturnPanel_searchWrapper__AYmEo`,
	"searchResults": `ReturnPanel_searchResults__8PprG`,
	"searchItem": `ReturnPanel_searchItem__OvmS8`,
	"productName": `ReturnPanel_productName__zyAPm`,
	"productBarcode": `ReturnPanel_productBarcode__GCf+e`
};
export default ___CSS_LOADER_EXPORT___;
